import { render, staticRenderFns } from "./child-ring-cell.vue?vue&type=template&id=7d96f6bc&scoped=true"
import script from "./child-ring-cell.vue?vue&type=script&lang=js"
export * from "./child-ring-cell.vue?vue&type=script&lang=js"
import style0 from "./child-ring-cell.vue?vue&type=style&index=0&id=7d96f6bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d96f6bc",
  null
  
)

export default component.exports